import "./App.css";
import "./mobile.css";
import "./card-premium.css";
import "./compatibility-dashboard.css";
import "./compatibility-universes.css";
import "./photo.css";
import "./commercial-session.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";
import { UserProvider, useUser } from "./context/UserContext";
import { SoundProvider } from "./context/SoundContext";
import UserSelector from "./components/UserSelector";
import Navigation from "./components/Navigation";
import Dashboard from "./pages/Dashboard";
import CardsView from "./pages/CardsView";
import MatchesView from "./pages/MatchesView";
import MyAnswersView from "./pages/MyAnswersView";
import PhotosView from "./pages/PhotosView";
import SettingsView from "./pages/SettingsView";
import PreviewCards from "./pages/PreviewCards";
import CreateSessionView from "./pages/CreateSessionView";
import JoinSessionView from "./pages/JoinSessionView";

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/cards" element={<CardsView />} />
        <Route path="/matches" element={<MatchesView />} />
        <Route path="/answers" element={<MyAnswersView />} />
        <Route path="/photos" element={<PhotosView />} />
        <Route path="/settings" element={<SettingsView />} />
        <Route path="/preview-cards" element={<PreviewCards />} />
        <Route path="/create" element={<CreateSessionView />} />
        <Route path="/join/:inviteCode" element={<JoinSessionView />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AnimatePresence>
  );
}

function Shell() {
  const { currentUserId, loading } = useUser();
  const location = useLocation();
  const isCommercialLobbyRoute = location.pathname === "/create" || location.pathname.startsWith("/join/");

  if (isCommercialLobbyRoute) {
    return (
      <div className="app-shell commercial-app-shell">
        <div className="ambient-glow" />
        <main className="app-main">
          <AnimatedRoutes />
        </main>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="ambient-glow" />
        <span className="loading-dot" />
      </div>
    );
  }

  if (!currentUserId) return <UserSelector />;

  return (
    <div className="app-shell">
      <div className="ambient-glow" />
      <main className="app-main">
        <AnimatedRoutes />
      </main>
      <Navigation />
    </div>
  );
}

function App() {
  return (
    <UserProvider>
      <SoundProvider>
        <BrowserRouter>
          <Toaster position="top-center" theme="dark" richColors />
          <Shell />
        </BrowserRouter>
      </SoundProvider>
    </UserProvider>
  );
}

export default App;
